import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ConsTakeInChargeDocumentType from './cons-take-in-charge-document-type';
import ConsTakeInChargeDocumentTypeDetail from './cons-take-in-charge-document-type-detail';
import ConsTakeInChargeDocumentTypeUpdate from './cons-take-in-charge-document-type-update';
import ConsTakeInChargeDocumentTypeDeleteDialog from './cons-take-in-charge-document-type-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ConsTakeInChargeDocumentTypeUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ConsTakeInChargeDocumentTypeUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ConsTakeInChargeDocumentTypeDetail} />
      <ErrorBoundaryRoute path={match.url} component={ConsTakeInChargeDocumentType} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ConsTakeInChargeDocumentTypeDeleteDialog} />
  </>
);

export default Routes;
